<div id="editor-cover">
  <div id="editorjs"></div>
</div>
